(function () {
  if (window.__smGift) return; window.__smGift = true;
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  // Free gift card: auto add/remove by cart value by amount paid after discounts ($50+ -> $10, $75+ -> $20, $100+ -> $40)
  var G10 = 50846315020427, G20 = 50846259413131, G40 = 50846259544203, gBusy = false;
  async function smGiftSync() {
    if (gBusy) return; gBusy = true;
    try {
      var cart = await (await fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })).json();
      var s = cart.total_price || 0, has10 = 0, has20 = 0, has40 = 0;
      cart.items.forEach(function (i) { if (i.variant_id === G10) has10 += i.quantity; else if (i.variant_id === G20) has20 += i.quantity; else if (i.variant_id === G40) has40 += i.quantity; });
      var w40 = s >= 10000 ? 1 : 0, w20 = !w40 && s >= 7500 ? 1 : 0, w10 = !w40 && !w20 && s >= 5000 ? 1 : 0;
      setCount(cart.item_count, has10 + has20 + has40, cart.total_price, (cart.original_total_price || 0) - (cart.total_price || 0));
      if (has10 === w10 && has20 === w20 && has40 === w40) return;
      var up = {}; if (has10 !== w10) up[G10] = w10; if (has20 !== w20) up[G20] = w20; if (has40 !== w40) up[G40] = w40;
      var ids = Array.from(new Set(Array.from(document.querySelectorAll('cart-items-component')).map(function (e) { return e.dataset.sectionId; }).filter(Boolean)));
      var r = await fetch(root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: up, sections: ids.join(','), sections_url: location.pathname }) });
      var j = await r.json(); if (!r.ok) return;
      setCount(j.item_count, w10 + w20 + w40, j.total_price, (j.original_total_price || 0) - (j.total_price || 0));
      try {
        var ev = await import('@shopify/events');
        var d = ev.CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(new ev.CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: Object.keys(up).map(function (k) { return { merchandiseId: String(k), quantity: up[k] }; }), promise: d.promise }));
        d.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(j), detail: { sections: j.sections, items: j.items, itemCount: j.item_count, source: 'sm-gift', didError: false } });
      } catch (e) { if (/\/cart\/?$/.test(location.pathname)) location.reload(); }
    } catch (e) {} finally { gBusy = false; }
  }
  // Header bubble + drawer badge: don't count the free gift card
  var CNT = { total: 0, gift: 0, price: null, saved: 0 };
  function fixCount() {
    var b = document.getElementById('checkout');
    if (b && CNT.price != null) { var t = '$' + (CNT.price / 100).toFixed(2), bt = b.querySelector('.button-text') || b; if (bt.getAttribute('data-sm-total') !== t) { bt.setAttribute('data-sm-total', t); b.setAttribute('data-sm-total', t); } Array.prototype.forEach.call(bt.childNodes, function (n) { if (n.nodeType === 3 && n.nodeValue.trim()) n.nodeValue = ''; }); }
    var ctas = document.querySelector('#cart-drawer .cart__ctas');
    if (ctas) {
      var sv = ctas.parentElement.querySelector('.sm-saved');
      if (!sv) { sv = document.createElement('p'); sv.className = 'sm-saved'; ctas.parentElement.insertBefore(sv, ctas); }
      var amt = CNT.saved > 0 ? '$' + (CNT.saved / 100).toFixed(2) : '', txt = amt ? 'You’re saving <b>' + amt + '</b> on this order' : '';
      if (sv.innerHTML !== txt) sv.innerHTML = txt;
      sv.hidden = !txt;
    }
    var sh = document.querySelector('#cart-drawer scroll-hint');
    if (sh) { var st = sh.getAttribute('style') || '', ns = st.replace(/black [\d.]+%, transparent 100%\)/, 'black 100%)'); if (ns !== st) sh.setAttribute('style', ns); }
    if (!CNT.gift) return;
    document.querySelectorAll('.cart-bubble__text-count, .theme-drawer__badge').forEach(function (e) {
      if (e.textContent.trim() === String(CNT.total)) e.textContent = String(Math.max(0, CNT.total - CNT.gift));
    });
  }
  function setCount(total, gift, price, saved) { CNT.total = total; CNT.gift = gift; if (price != null) CNT.price = price; if (saved != null) CNT.saved = saved; fixCount(); setTimeout(fixCount, 400); setTimeout(fixCount, 1200); }
  var ct; new MutationObserver(function () { clearTimeout(ct); ct = setTimeout(fixCount, 30); }).observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style'] });
  window.smGiftSync = smGiftSync;
  if (!window.__smCartWatch) {
    window.__smCartWatch = [];
    var of = window.fetch;
    window.fetch = function (i) {
      var u = String((i && i.url) || i || ''), p = of.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(function () { setTimeout(function () { window.__smCartWatch.forEach(function (f) { f(); }); }, 250); }, function () {});
      return p;
    };
  }
  window.__smCartWatch.push(function () { setTimeout(smGiftSync, 150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', smGiftSync); else smGiftSync();
})();
